export default "__VITE_ASSET__CA$az8VV__"